// @ts-nocheck
import { useEffect } from "react";
import { store } from "../../store/store";
import { alertDialogAciton } from "../../store/actions/auth";
import { CLEAR_EMAIL_REDIRECTION_REDUCER } from "../../store/constants/emailRedirectionConstants";

let askedOnce = false;

export function useQrAppPrompt(showAlert) {
  useEffect(() => {
    const pathname = location.pathname;
    if (askedOnce) return;
    // if (pathname != "/qr-data" || pathname != "/login") return;
    const redirectPath = store.getState()?.emailRedirection?.path ?? "";
    const isQrData = pathname === "/qr-data";
    const isLoginToQr = pathname === "/login" && redirectPath === "/qr-data";
    if (!isQrData && !isLoginToQr) return;

    // Detect platform
    const ua = navigator.userAgent.toLowerCase();
    const isIOS =
      /iphone|ipad|ipod/.test(ua) ||
      (ua.includes("macintosh") && navigator.maxTouchPoints > 1); // iPad detection
    const isAndroid = ua.includes("android");
    const isMac = ua.includes("macintosh") && navigator.maxTouchPoints <= 1; // Real Mac
    const isWindows = ua.includes("windows");
    const isLinux = ua.includes("linux") && !isAndroid;

    // If it's desktop, return early
    if ((isMac || isWindows || isLinux) && !isIOS) {
      return;
    }

    askedOnce = true;

    store.dispatch(
      alertDialogAciton({
        open: true,
        title: "Download App?",
        message:
          "We detected a QR Code. Would you like to open the ShowPhaze mobile app or continue on web?",
        okLabel: "Download App",
        onOk: () => {
          // const appLink = `noname://app/qr-data?data=${encodeURIComponent(qrData ?? "")}&email=${encodeURIComponent(email ?? "")}`;

          store.dispatch({
            type: CLEAR_EMAIL_REDIRECTION_REDUCER,
          });

          if (isAndroid) {
            // window.location.href = appLink;
            setTimeout(() => {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.app.showphaze&hl=en_IN";
            }, 500);
          } else if (isIOS) {
            // window.location.href = appLink;
            setTimeout(() => {
              window.location.href =
                "https://apps.apple.com/us/app/showphaze/id6503709618";
            }, 500);
          } else {
            window.alert("Please open this link on your mobile device.");
          }
        },
        closeLabel: "Continue on Web",
        // onClose: () => {
        //   store.dispatch({
        //     type: CLEAR_EMAIL_REDIRECTION_REDUCER,
        //   });
        // },
      }),
    );
  }, [showAlert, location?.pathname]);
}